<template>
  <div id="template-editor-modal">

    <ErrorPopup
      :error="error"
    />

    <TemplateSelectThemeModal 
      ref="select-theme-modal"
      @selected="selected_theme_template"
    />

    <memlist-modal ref="edit-template" :size="size">
      
      <TemplateEmailEdit
        v-if="type === 'EMAIL'"
        :source="source"
        ref="template-editor"
        @cancel="on_cancel"
        @updated="updated_template"
        :item="local_item"
        @created="created_template"
      />

      <TemplateSMSEdit
        v-if="type === 'SMS'"
        :source="source"
        ref="template-editor"
        @cancel="on_cancel"
        @updated="updated_template"
        :item="local_item"
        @created="created_template"
      />
      
    
    </memlist-modal>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import ErrorPopup from '@/view/components/ErrorPopup.vue';
import TemplateEmailEdit from '@/view/pages/ml/templates/TemplateEmailEdit.vue';
import TemplateSMSEdit from '@/view/pages/ml/templates/TemplateSMSEdit.vue';
import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';
import TemplateSelectThemeModal from '@/view/pages/ml/templates/TemplateSelectThemeModal.vue';

export default {
  name: 'TemplateEditorModal',
  components: {
    TemplateEmailEdit,
    TemplateSMSEdit,
    ErrorPopup,
    RightModalSaveAndCloseButtons,
    TemplateSelectThemeModal
  },
  mixins: [ toasts ],
  
  computed: {
    size() {
      return this.type === 'EMAIL' ? 'full' : 'xl';
    },
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'settings']),
    
  },

  props: ['template_id','type','source'],
  emits: ['created', 'updated'],
  async mounted() {
  
  },
  watch: {
    template_id() {
      if (this.template_id) {
        this.fetch_template(this.template_id);
      }
    },
  },
  methods: {
    create() {
      if (this.type === 'EMAIL') {
        this.local_item = {
          is_sms: false,
          is_email: true,
          name: 'Ny e-postmall',
        };

        this.$refs['select-theme-modal'].show();
      }
      else {
        this.local_item = {
          from_id: this.settings.sms_id,
          is_sms: true,
          is_email: false,
          name: 'Ny SMS mall',
        };
      
        this.$refs['edit-template'].show();
      }
    },
    
    on_cancel() {
      
      this.$nextTick(()=>{
        this.$refs['edit-template'].hide();  
      });
    },
    
    
    show() {
      
      this.$nextTick(()=>{
        this.$refs['edit-template'].show();  
      });
    },

    created_template(item) {
      this.$emit('created', item);
    },

    updated_template(item) {
      this.$emit('updated', item);
    },

    async fetch_template(template_id) {
      const res = await axios.get(`/template/${template_id}`);

      if (res.status === 200) {
        this.local_item = res.data;

        if (this.local_item.is_email) {
          this.local_item.edit_html = this.local_item.edit_html ? JSON.parse(this.local_item.edit_html) : null;
        }
      }
    },

    async selected_theme_template(template) {
      const loader = this.$loading.show();

      try {
        const res = await axios.post(`/template/copy`, { template_id: template.template_id });

        if (res.status === 201) {
          this.local_item = { ...res.data };
          this.$emit('created', this.local_item);
          
          this.$nextTick(()=>{
            this.$refs['edit-template'].show();
          });
          
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.COPIED'));
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_COPY'));
        }
      }
      catch (err) {
        console.error('selected_theme_template error', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_COPY'));
      }

      loader && loader.hide();
    },

  },
  data() {
    return {
      local_item: {},
      error: null
    };
  },
  
};
</script>
<style lang="scss" scoped>

:deep .v-treeview-node__root:hover {
  cursor: pointer;
}

.tree-panel {
  background-color: white;
}

:deep .v-simple-checkbox {
  float: left;
  width: 22px;
  margin-left: 8px;
}

:deep .v-input__slot label {
  font-size: 12px;
}

:deep .v-data-table__wrapper tr:first-child {
  height: 66px;
  background-color: rgb(239, 239, 239) !important;
}

@media (min-width: 1200px) {
  :deep .modal-dialog.modal-xl {
    max-width: 1400px;
  }
}

</style>
